import { axios } from '@/services/axios';

const convertFromTrial = async (companyId, currentScope) => {
    const res = await axios.post(`/Company/ConvertFromTrial/${companyId}`, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};
export default convertFromTrial;
